import { ReactNode } from "react";
import { Navigate, useLocation, RouteProps } from "react-router-dom";
import { useAppSelector } from "app/hooks";
import { PRE_AUTH_USER_ID, selectCurrentUser } from "features/auth/auth-slice";
import useUserRoles from "hooks/use-user-roles.hook";
import { GroupType } from "services/types/staff.type";
import {
  hasAccessRestrictions,
  hasRequiredAccess,
} from "../utils/auth-access.utils";

interface ProtectedRouteProps extends RouteProps {
  roles?: GroupType[];
  permissions?: string[];
  children: ReactNode;
}

const ProtectedRoute = ({
  children,
  roles,
  permissions,
}: ProtectedRouteProps) => {
  const currentUser = useAppSelector(selectCurrentUser);
  const location = useLocation();
  const { userRoles, userPermissions } = useUserRoles();
  if (
    currentUser.id === PRE_AUTH_USER_ID ||
    !hasAccessRestrictions(roles, permissions) ||
    hasRequiredAccess(
      currentUser,
      userRoles,
      userPermissions,
      roles,
      permissions
    )
  ) {
    return <>{children}</>;
  } else {
    return <Navigate to="/permission" state={{ from: location }} replace />;
  }
};

export default ProtectedRoute;
